import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowUpRight, MagnifyingGlass } from "@phosphor-icons/react";

export default function NotFoundPage() {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <div
      data-testid="notfound-page"
      className="px-6 md:px-10 lg:px-16 py-20 md:py-32 max-w-4xl"
    >
      {/* Editorial 404 masthead */}
      <div className="overline mb-4">Error · 404</div>
      <div className="font-display font-black tracking-[-0.05em] leading-[.9] mb-8">
        <div className="text-[8rem] md:text-[14rem] text-zinc-950">404</div>
      </div>
      <h1 className="font-display font-bold text-3xl md:text-4xl tracking-tight leading-tight mb-4">
        {t("notFound.title")}
      </h1>
      <p className="text-zinc-600 text-lg leading-relaxed max-w-xl">
        {t("notFound.body")}{" "}
        <span className="font-mono text-sm text-zinc-500 break-all">
          {location.pathname}
        </span>
      </p>

      <div className="mt-10 flex flex-wrap items-center gap-3">
        <Link
          to="/"
          data-testid="notfound-home-btn"
          className="btn-primary"
        >
          {t("notFound.homeCta")} <ArrowUpRight size={14} data-arrow="forward" />
        </Link>
        <Link
          to="/conferences"
          data-testid="notfound-browse-btn"
          className="btn-secondary"
        >
          <MagnifyingGlass size={14} /> {t("notFound.browseCta")}
        </Link>
      </div>

      {/* Discreet crumb list */}
      <div className="mt-16 border-t border-zinc-200 pt-6">
        <div className="overline mb-3">{t("notFound.tryOneOf")}</div>
        <ul className="text-sm space-y-1.5">
          <li>
            <Link to="/conferences" className="hover:underline">
              {t("nav.conferences")}
            </Link>
          </li>
          <li>
            <Link to="/speakers" className="hover:underline">
              {t("nav.speakers")}
            </Link>
          </li>
          <li>
            <Link to="/papers" className="hover:underline">
              {t("nav.papers")}
            </Link>
          </li>
          <li>
            <Link to="/cfp" className="hover:underline">
              {t("nav.cfp")}
            </Link>
          </li>
          <li>
            <Link to="/map" className="hover:underline">
              {t("nav.atlas")}
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}
